
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ZNsj", function(module, exports) {
/* BannerContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9SBTM = parcelRequire("9SBTM");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jmjWc = parcelRequire("jmjWc");


const $10edbccaeb321332$export$d71d84f1864a608a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4qwYp",
    name: "SuperAdminBanner",
    loader: async ()=>(await (parcelRequire("1qNpL"))).SuperAdminBanner
});


/* PageWasInactiveBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $irVI7 = parcelRequire("irVI7");


var $3XjWl = parcelRequire("3XjWl");


var $2KpT3 = parcelRequire("2KpT3");





var $aJv6Q = parcelRequire("aJv6Q");


var $hrAmX = parcelRequire("hrAmX");


var $18HQ4 = parcelRequire("18HQ4");


var $cbc8g = parcelRequire("cbc8g");

const $880f9466dc5f2c8e$var$i18n = (0, $cgtv4.defineMessages)({
    pageWasBackgrounded: {
        id: "browser-status-indicator.page.was.backgrounded",
        defaultMessage: "Your content may not have fully loaded. Try to {refreshLink}"
    },
    refreshLink: {
        id: "browser-status-indicator.refresh.the.page",
        defaultMessage: "refresh now"
    }
});
const $880f9466dc5f2c8e$var$BANNER_NAME = 'PageWasInactiveBanner';
const $880f9466dc5f2c8e$var$BANNER_HEIGHT = 32; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $880f9466dc5f2c8e$var$PageWasInactiveBannerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3izwfg _1e0c1txw _bfhkysee _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $880f9466dc5f2c8e$var$RefreshLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledRefreshLink), {
        target: "_blank",
        onClick: ()=>window.location.reload()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $880f9466dc5f2c8e$var$i18n.refreshLink, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, text)));
// Experiences to track
const $880f9466dc5f2c8e$var$EXPERIENCES = [
    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
]; // Delay before making this banner become visible
// when viewing a tab that was previously hidden.
const $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY = 1000;
const $880f9466dc5f2c8e$export$91f065510e8e6998 = /*#__PURE__*/ (0, $42omo.memo)(({ bannerState: bannerState })=>{
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(false);
    const experienceStates = $880f9466dc5f2c8e$var$EXPERIENCES.map((0, $3XjWl.useExperienceState));
    (0, $42omo.useEffect)(()=>{
        const changeVisibility = ()=>{
            // When a tab's visibility changes, wait a small amount before updating documentVisible.
            // This prevents a flicker of this banner that sometimes occurs
            // when a tab that is loading in the background becomes visible.
            setTimeout(()=>{
                setDocumentVisible(!document.hidden);
            }, $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY);
        };
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>document.removeEventListener('visibilitychange', changeVisibility);
    });
    const showBanner = documentVisible && experienceStates.some((experienceState)=>{
        // dont show the banner if:
        // !experienceState - if an experience has not started
        // !experienceState.timeout - if the experience does not rely on timeout
        if (!experienceState || !experienceState.timeout) return false;
        const { startTime: startTime = 0, timeout: timeout, hasStopped: hasStopped } = experienceState;
        const absoluteDuration = Math.round(window.performance.now() - startTime);
        const adjustedTabActiveTime = absoluteDuration - (0, $2KpT3.getTabInactivityTracker)().getInactiveMillisecondsSince(startTime);
        const insufficientActiveTime = adjustedTabActiveTime < timeout;
        return !hasStopped && insufficientActiveTime;
    });
    if (showBanner) {
        bannerState.show($880f9466dc5f2c8e$var$BANNER_NAME, $880f9466dc5f2c8e$var$BANNER_HEIGHT);
        (0, $cbc8g.addUFOCustomData)({
            isPageWasInactiveBannerDisplayed: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($880f9466dc5f2c8e$var$PageWasInactiveBannerContainer, {
            "data-testid": "inactive-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.FadingSpan), {
            show: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$880f9466dc5f2c8e$var$i18n.pageWasBackgrounded,
            values: {
                refreshLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($880f9466dc5f2c8e$var$RefreshLink, null)
            }
        }))));
    } else {
        bannerState.hide($880f9466dc5f2c8e$var$BANNER_NAME);
        return null;
    }
});
const $880f9466dc5f2c8e$export$6d11cadf32c4517a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($880f9466dc5f2c8e$export$91f065510e8e6998, {
            bannerState: bannerState
        });
    });
});






const $d686d040b673d1ca$export$f449ad63dc7e8a0f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lkLmI",
    name: "AdminAnnouncementBanner",
    loader: async ()=>(await (parcelRequire("k7pji"))).AdminAnnouncementBanner
});






const $fde0386be42ce743$export$25e97e90a802d73 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "k7WTy",
    name: "GracePeriodBanner",
    loader: async ()=>(await (parcelRequire("7JbbK"))).GracePeriodBanner
});









var $alLTz = parcelRequire("alLTz");


const $a393ba0851d433ea$var$StorageEnforcementBannerLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VZcGs",
    name: "StorageEnforcementBannerLoadable",
    loader: async ()=>(await (parcelRequire("8siu5"))).StorageEnforcementBanner
});
const $a393ba0851d433ea$export$8140039602269ff0 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a393ba0851d433ea$var$StorageEnforcementBannerLoadable, null) : null;
};



var $frIzR = parcelRequire("frIzR");











var $jSnXV = parcelRequire("jSnXV");


var $4JDbp = parcelRequire("4JDbp");














var $6mKj3 = parcelRequire("6mKj3");





var $inPa6 = parcelRequire("inPa6");





var $9imv3 = parcelRequire("9imv3");


var $a3jGG = parcelRequire("a3jGG");

const $403d7842519953c9$export$afc8b28843b075c1 = 105;
const $403d7842519953c9$export$41956b146268af93 = 'CookiesConsentBanner';


function $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb(bannerState, bannerRef) {
    const cookiesDialogRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [height, setHeight] = (0, $42omo.useState)((0, $403d7842519953c9$export$afc8b28843b075c1));
    const prefetchedData = Object.keys(window?.__COOKIE_CONSENT_PREFERENCES__ || {}).length ? window.__COOKIE_CONSENT_PREFERENCES__ : undefined;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    // Use useMemo to calculate shouldRenderInitial only once, regardless of SSR or client
    const shouldRenderInitial = (0, $42omo.useMemo)(()=>{
        // TODO fix hacky ternary because of type issue
        // If there is no data, it may be because there is not a userId. Defer to package internal logic to determine whether to render
        const initialValue = prefetchedData ? (0, $9imv3.shouldRenderBannerPrefetched)(prefetchedData) : (0, $9imv3.shouldRenderBannerPrefetched)();
        // Only register banner during SSR
        if (isSSR && initialValue) (0, $a3jGG.ssrBannerManager).registerBanner({
            name: (0, $403d7842519953c9$export$41956b146268af93),
            height: (0, $403d7842519953c9$export$afc8b28843b075c1)
        });
        return initialValue;
    }, [
        prefetchedData,
        isSSR
    ]);
    const [shouldRender, setShouldRender] = (0, $42omo.useState)(isSSR ? shouldRenderInitial : null);
    if (shouldRender) bannerState?.show((0, $403d7842519953c9$export$41956b146268af93), height);
    else if (shouldRender === false) bannerState?.hide((0, $403d7842519953c9$export$41956b146268af93));
    const findCookiesDialog = (0, $42omo.useCallback)(()=>{
        if (cookiesDialogRef?.current) return cookiesDialogRef?.current;
        if (!bannerRef?.current) return null;
        const childDivs = bannerRef?.current.getElementsByTagName('div');
        let cookiesDialog = null;
        for (const element of Object.values(childDivs)){
            if (!element.offsetHeight) continue;
            // @ts-ignore - Type 'HTMLDivElement' is not assignable to type 'null'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            cookiesDialog = element;
            break;
        }
        cookiesDialogRef.current = cookiesDialog;
        return cookiesDialog;
    }, [
        bannerRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldRender || shouldRenderInitial) (0, $cbc8g.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true,
            ...prefetchedData && {
                prefetchedConsentPreferences: JSON.stringify(prefetchedData)
            }
        });
    }, [
        shouldRender,
        shouldRenderInitial,
        prefetchedData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldRender) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            action: 'rendered',
            actionSubject: 'cookiesConsentBanner'
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRender
    ]);
    const onWidthChange = (0, $42omo.useCallback)(()=>{
        const cookiesDialog = findCookiesDialog();
        if (!cookiesDialog) return;
        (0, $cbc8g.addUFOCustomData)({
            cookieBannerHeight: cookiesDialog.offsetHeight
        });
        setHeight(cookiesDialog.offsetHeight);
    }, [
        findCookiesDialog
    ]);
    const showBanner = (0, $42omo.useCallback)(()=>{
        setShouldRender(true);
        onWidthChange();
    }, [
        onWidthChange
    ]);
    const hideBanner = (0, $42omo.useCallback)(()=>{
        setShouldRender(false);
    }, []);
    return {
        shouldRender: shouldRender,
        showBanner: showBanner,
        hideBanner: hideBanner,
        onWidthChange: onWidthChange,
        prefetchedData: prefetchedData
    };
}



// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62400dd446426ff7$var$Banner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62400dd446426ff7$var$BannerContent = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

const $62400dd446426ff7$var$ConsentBannerComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BMpKa",
    name: "ConsentBannerComponent",
    loader: async ()=>(await (parcelRequire("2aL6v"))).ConsentBannerWrapper
});
const $62400dd446426ff7$var$CookieConsentBannerComponentInSuspense = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    if ((0, $6mKj3.expVal)("confluence_cookie_consent_banner_suspense", "isEnabled", false)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                fallback: null
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return children;
};
const $62400dd446426ff7$var$CookiesConsentBannerComponent = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { bannerState: bannerState } = t0;
    const bannerRef = (0, $42omo.useRef)(null);
    const { onWidthChange: onWidthChange, showBanner: showBanner, hideBanner: hideBanner, prefetchedData: prefetchedData } = (0, $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb)(bannerState, bannerRef);
    let t1;
    if ($[0] !== onWidthChange) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onWidthChange, 50);
        $[0] = onWidthChange;
        $[1] = t1;
    } else t1 = $[1];
    const onResize = t1;
    let t2;
    if ($[2] !== onResize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.WidthObserver), {
            setWidth: onResize
        });
        $[2] = onResize;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== hideBanner || $[5] !== prefetchedData || $[6] !== showBanner) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62400dd446426ff7$var$ConsentBannerComponent, {
            product: "Confluence",
            onShow: showBanner,
            onHide: hideBanner,
            initialPreferences: prefetchedData,
            newMinHeight: (0, $403d7842519953c9$export$afc8b28843b075c1)
        });
        $[4] = hideBanner;
        $[5] = prefetchedData;
        $[6] = showBanner;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62400dd446426ff7$var$Banner, {
            ref: bannerRef,
            role: "banner",
            "data-testid": "cookie-consent-banner",
            "data-vc": "cookie-consent-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62400dd446426ff7$var$BannerContent, null, t2, t3));
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
const $62400dd446426ff7$export$494acd77efce1d72 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, $62400dd446426ff7$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $62400dd446426ff7$var$_temp(bannerState) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62400dd446426ff7$var$CookieConsentBannerComponentInSuspense, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62400dd446426ff7$var$CookiesConsentBannerComponent, {
        bannerState: bannerState
    }));
}











var $8C5kA = parcelRequire("8C5kA");


var $4FYDR = parcelRequire("4FYDR");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");











var $eSDUO = parcelRequire("eSDUO");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $04e9M = parcelRequire("04e9M");


var $cMvQV = parcelRequire("cMvQV");

// This file was automatically generated and should not be edited.
const $09adc8c702586d16$export$88284c4a582e5a0c = /Edge?\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/(7[89]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(16\.([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(8[5-9]|9\d|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(16[._]([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android:?[ /-](129|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Mobile Safari.+OPR\/([89]\d|\d{3,})\.\d+\.\d+|Android.+Firefox\/(13\d|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(129|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+(UC? ?Browser|UCWEB|U3)[ /]?(15\.([5-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)\.\d+|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+|Android.+MQ{2}Browser\/(14(\.(9|\d{2,})|)|(1[5-9]|[2-9]\d|\d{3,})(\.\d+|))(\.\d+|)|K[Aa][Ii]OS\/(3\.\d+|([4-9]|\d{2,})\.\d+)(\.\d+|)/;


const $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c = ()=>!(0, $09adc8c702586d16$export$88284c4a582e5a0c).test(navigator.userAgent);





const $a0d38a398101db6d$var$BANNER_HEIGHT = 72; // 72px when gridSize = 8px
const $a0d38a398101db6d$var$BANNER_NAME = 'UnsupportedBrowserBanner';
const $a0d38a398101db6d$var$messages = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "unsupported-browser-banner.banner-message",
        defaultMessage: "Your browser is <link>unsupported</link>. Switch or upgrade to maintain optimal performance."
    },
    bannerLink: {
        id: "unsupported-browser-banner.banner-link",
        defaultMessage: "unsupported"
    }
});
const $a0d38a398101db6d$var$BannerLink = (str)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__fe-platform-an') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "https://support.atlassian.com/atlassian-account/docs/supported-browsers-for-atlassian-cloud-products/",
        target: "_blank",
        rel: "noreferrer noopener"
    }, str) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: "https://support.atlassian.com/atlassian-account/docs/supported-browsers-for-atlassian-cloud-products/",
        target: "_blank",
        rel: "noreferrer noopener"
    }, str);
const $a0d38a398101db6d$var$UnsupportedBrowserBannerComponent = ({ bannerState: bannerState, setIsBannerClosed: setIsBannerClosed, isBannerClosed: isBannerClosed })=>{
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const bannerClosedByUser = (0, $17wUi.confluenceSessionStorageInstance).getItemAsBoolean((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER);
        if (bannerClosedByUser) {
            setIsBannerClosed(true);
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
        }
    }, [
        setIsBannerClosed,
        isBannerClosed,
        bannerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSDUO.DismissibleBanner), {
        height: $a0d38a398101db6d$var$BANNER_HEIGHT,
        isWarning: true,
        onDismiss: ()=>{
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
            setIsBannerClosed(true);
            (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER, true);
        }
    }, intl.formatMessage($a0d38a398101db6d$var$messages.bannerMessage, {
        link: $a0d38a398101db6d$var$BannerLink
    }));
};
const $a0d38a398101db6d$export$77b99dfa740609c2 = ()=>{
    const [isBannerClosed, setIsBannerClosed] = (0, $42omo.useState)(true);
    const failedFullCapabilitiesBrowserCheck = (0, $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c)();
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $42omo.useEffect)((0, $cMvQV.setUserAgent), []);
    // Display banner if full browser capabilities check failed
    (0, $42omo.useEffect)(()=>{
        if (failedFullCapabilitiesBrowserCheck) setIsBannerClosed(false);
    }, [
        failedFullCapabilitiesBrowserCheck,
        setIsBannerClosed
    ]);
    const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($4FYDR)))(navigator.userAgent);
    const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
    // collect analytics
    (0, $42omo.useEffect)(()=>{
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent({
                source: 'unsupportedBrowserBanner',
                action: 'executed',
                actionSubject: 'browserRuntimeCheck',
                attributes: {
                    failedFullBrowserCheck: failedFullCapabilitiesBrowserCheck,
                    browserName: browserName,
                    browserVersion: browserVersion
                }
            });
        });
    }, [
        failedFullCapabilitiesBrowserCheck,
        browserName,
        browserVersion
    ]);
    if (isBannerClosed || !failedFullCapabilitiesBrowserCheck || (0, $cMvQV.isNativeMobile)() // Do not render the banner in the Confluence native mobile app
    ) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        bannerState.show($a0d38a398101db6d$var$BANNER_NAME, $a0d38a398101db6d$var$BANNER_HEIGHT);
        (0, $cbc8g.addUFOCustomData)({
            isUnsupportedBrowserBannerDisplayed: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0d38a398101db6d$var$UnsupportedBrowserBannerComponent, {
            bannerState: bannerState,
            setIsBannerClosed: setIsBannerClosed,
            isBannerClosed: isBannerClosed
        });
    }));
};



var $9mLIQ = parcelRequire("9mLIQ");


var $luv00 = parcelRequire("luv00");

const $6d2b0b868a2f629c$export$75cf49eb39e36c7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _1bsb1osq _154iidpf _1ltvidpf _1pby1fss",
            __cmplp.className
        ])
    });
});
const $6d2b0b868a2f629c$var$BannerContainerComponent = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d2b0b868a2f629c$export$75cf49eb39e36c7, {
        "data-vc": "banner-container-component",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fde0386be42ce743$export$25e97e90a802d73), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10edbccaeb321332$export$d71d84f1864a608a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $880f9466dc5f2c8e$export$6d11cadf32c4517a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a393ba0851d433ea$export$8140039602269ff0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d686d040b673d1ca$export$f449ad63dc7e8a0f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $62400dd446426ff7$export$494acd77efce1d72), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0d38a398101db6d$export$77b99dfa740609c2), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mLIQ.DevToolsBanner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9SBTM.BannerSpacer), props));
};
const $6d2b0b868a2f629c$export$f316edcbf748c37b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($6d2b0b868a2f629c$var$BannerContainerComponent);
module.exports["BannerPositioner"] = $6d2b0b868a2f629c$export$75cf49eb39e36c7;
module.exports["BannerContainer"] = $6d2b0b868a2f629c$export$f316edcbf748c37b;

});

parcelRegister("9SBTM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $39c6bc3fe89269a3$export$6801ec5f8af8462d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bwedP",
    name: "BannerSpacer",
    loader: async ()=>(await (parcelRequire("jya5V"))).BannerSpacer
});
module.exports["BannerSpacer"] = $39c6bc3fe89269a3$export$6801ec5f8af8462d;

});

parcelRegister("jya5V", function(module, exports) {

let $e3b905db011acaa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3b905db011acaa7$var$load("9mi9f").then(()=>parcelRequire('HJnwX'));

});

parcelRegister("1qNpL", function(module, exports) {

let $10ae8cd844ff0443$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10ae8cd844ff0443$var$load("kiqoj").then(()=>parcelRequire('hnH0O'));

});

parcelRegister("3XjWl", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const $ = (0, $frIzR.c)(7);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== experienceName || $[1] !== experienceTracker) {
        t0 = experienceTracker.getExperienceState(experienceName);
        $[0] = experienceName;
        $[1] = experienceTracker;
        $[2] = t0;
    } else t0 = $[2];
    const [experienceState, setExperienceState] = (0, $42omo.useState)(t0);
    let t1;
    let t2;
    if ($[3] !== experienceName || $[4] !== experienceTracker) {
        t1 = ()=>experienceTracker.subscribe((e)=>{
                if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
            });
        t2 = [
            experienceName,
            experienceTracker
        ];
        $[3] = experienceName;
        $[4] = experienceTracker;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
    return experienceState;
};
module.exports["useExperienceState"] = $a5d6810b007644fc$export$4a4fb33de7d01f75;

});

parcelRegister("18HQ4", function(module, exports) {
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhkysee _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhk1y9u" : "_bfhkysee",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $7sObp.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pwu06 _1wyb1crf _syaz1rpy _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _11q71rpy _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _k48pwu06 _syaz1oa5",
            __cmplp.className
        ])
    });
});
module.exports["StatusIndicator"] = $4dfb2d8a6603cd21$export$b4f88f0ca5784eef;
module.exports["StyledText"] = $4dfb2d8a6603cd21$export$31ea92f3997410dd;
module.exports["FadingSpan"] = $4dfb2d8a6603cd21$export$bb5d4b172e6970cd;
module.exports["EllipsisContainer"] = $4dfb2d8a6603cd21$export$91672a4b819b5126;
module.exports["AnimatedDot"] = $4dfb2d8a6603cd21$export$c30cc6d619162254;
module.exports["StyledRefreshLink"] = $4dfb2d8a6603cd21$export$b9ead157d7292e86;

});

parcelRegister("k7pji", function(module, exports) {

let $ea581831983d7138$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea581831983d7138$var$load("kUbUu"),
    $ea581831983d7138$var$load("6wr18"),
    $ea581831983d7138$var$load("eIzhm"),
    $ea581831983d7138$var$load("2Mq3f"),
    $ea581831983d7138$var$load("ffEVr"),
    $ea581831983d7138$var$load("hhss7"),
    $ea581831983d7138$var$load("jXx9i"),
    $ea581831983d7138$var$load("20dNF"),
    $ea581831983d7138$var$load("1zt4N"),
    $ea581831983d7138$var$load("iqKwT"),
    $ea581831983d7138$var$load("kULV9"),
    $ea581831983d7138$var$load("euYY7"),
    $ea581831983d7138$var$load("kC80R"),
    $ea581831983d7138$var$load("fbsPn")
]).then(()=>parcelRequire('64Kn9'));

});

parcelRegister("7JbbK", function(module, exports) {

let $5a056a277bdc13f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a056a277bdc13f7$var$load("7FRNR"),
    $5a056a277bdc13f7$var$load("eUy1m"),
    $5a056a277bdc13f7$var$load("3yFw0"),
    $5a056a277bdc13f7$var$load("6wr18"),
    $5a056a277bdc13f7$var$load("jfplD"),
    $5a056a277bdc13f7$var$load("9ET5T"),
    $5a056a277bdc13f7$var$load("3Xhte"),
    $5a056a277bdc13f7$var$load("ffEVr"),
    $5a056a277bdc13f7$var$load("7EorR"),
    $5a056a277bdc13f7$var$load("dRpV3"),
    $5a056a277bdc13f7$var$load("hhss7"),
    $5a056a277bdc13f7$var$load("jXx9i"),
    $5a056a277bdc13f7$var$load("8lj0L"),
    $5a056a277bdc13f7$var$load("cjDIz")
]).then(()=>parcelRequire('1gsg0'));

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("8siu5", function(module, exports) {

let $627f46d81f9a3672$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $627f46d81f9a3672$var$load("6wr18"),
    $627f46d81f9a3672$var$load("ffEVr"),
    $627f46d81f9a3672$var$load("7EorR"),
    $627f46d81f9a3672$var$load("dRpV3"),
    $627f46d81f9a3672$var$load("4uVag")
]).then(()=>parcelRequire('3Atou'));

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("9imv3", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $6RCHl = parcelRequire("6RCHl");


var $hvqgK = parcelRequire("hvqgK");


var $6gmJj = parcelRequire("6gmJj");


var $26elP = parcelRequire("26elP");

const $f8293df513318b39$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $6gmJj.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $26elP.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data
    if (// do not clean up confluence_ssr_cookie_banner_black_space - I will clean it up after jfp-magma-ssr-cookie-banner-hydration rolls out
    (0, $dh538.fg)('jfp-magma-ssr-cookie-banner-hydration') || (0, $c6GJD.default).getExperimentValue('confluence_ssr_cookie_banner_black_space', 'isEnabled', false)) {
        // Check if we have consents using same logic as shouldShowBannerInSSRContext
        // to prevent mismatches where space is reserved but UI doesn't render
        const prefetchedDataHasConsents = (0, $hvqgK.hasPrefetchedDataConsents)(prefetchedPreferencesData);
        if (prefetchedDataHasConsents) return false;
    }
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $6RCHl.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $26elP.getBannerVisibility)(consentPrefsData);
};
module.exports["shouldRenderBannerPrefetched"] = $f8293df513318b39$export$6406464aa126433e;

});

parcelRegister("a3jGG", function(module, exports) {
class $6069cdb664c4b392$export$c5377c2d90c2873e {
    registerBanner({ name: name, height: height }) {
        const bannerIndex = this.banners.findIndex((_banner)=>name === _banner.name);
        if (bannerIndex < 0) this.banners.push({
            name: name,
            height: height
        });
    }
    hasOtherBanners(bannerName) {
        return this.banners.some((banner)=>banner.name !== bannerName);
    }
    getBanners() {
        return this.banners;
    }
    clearBanners() {
        this.banners.length = 0;
    }
    constructor(){
        this.banners = [];
    }
}


const $dadf684901449c5e$export$6f28ab7c6647e579 = new (0, $6069cdb664c4b392$export$c5377c2d90c2873e)();
module.exports["ssrBannerManager"] = $dadf684901449c5e$export$6f28ab7c6647e579;

});

parcelRegister("2aL6v", function(module, exports) {

let $19510dd3291185a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19510dd3291185a2$var$load("9FU4d"),
    $19510dd3291185a2$var$load("kHOMt"),
    $19510dd3291185a2$var$load("hhss7"),
    $19510dd3291185a2$var$load("hmjlF")
]).then(()=>parcelRequire('hs7Sl'));

});

parcelRegister("eSDUO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $hQNhB = parcelRequire("hQNhB");


var $ebrpi = parcelRequire("ebrpi");


var $hmuev = parcelRequire("hmuev");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1neqek2": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt4ze3t _1bsb1osq _vchhusvi _4t3i2nrh _y3gn1h6o _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT = 28; // 28px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_FONT_SIZE = $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT / 2; // 14px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$Banner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _c71l1f4h _1wybdlk8 _k48p1wq8",
            __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
            __cmplp.isWarning ? "_syaz1yd3" : "_syaz15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerContent = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81s16 _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_SIZE = 24;
// 24px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_RIGHT_OFFSET = 10;
// 10px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerDismissButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg _80omtlke _kqswstnw _1xi219bv",
            __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
            __cmplp.isWarning ? "_syaz1yd3" : "_syaz15cr",
            __cmplp.isWarning ? "_30l31yd3" : "_30l315cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerMessages = (0, $cgtv4.defineMessages)({
    closeLabel: {
        id: "banners.dismissible-banner.close-label",
        defaultMessage: "Close"
    }
});
const $77f2946a7e231fe8$export$f43e5701f59b92d6 = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { height: height, children: children, onView: t1, onDismiss: t2, isWarning: t3 } = t0;
    const onView = t1 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))) : t1;
    const onDismiss = t2 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))) : t2;
    const isWarning = t3 === undefined ? false : t3;
    const intl = (0, $8C5kA.default)();
    let t4;
    let t5;
    if ($[0] !== onView) {
        t4 = ()=>{
            onView();
        };
        t5 = [
            onView
        ];
        $[0] = onView;
        $[1] = t4;
        $[2] = t5;
    } else {
        t4 = $[1];
        t5 = $[2];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    bb0: {
        let t7;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                role: "alert"
            };
            $[3] = t7;
        } else t7 = $[3];
        const baseProps = t7;
        if (!isWarning) {
            let t8;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t8 = {
                    ...baseProps,
                    "aria-label": "announcement",
                    tabIndex: 0,
                    role: "region"
                };
                $[4] = t8;
            } else t8 = $[4];
            t6 = t8;
            break bb0;
        }
        t6 = baseProps;
    }
    const accessibilityProps = t6;
    let t7;
    if ($[5] !== isWarning) {
        t7 = isWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: "Warning icon"
        });
        $[5] = isWarning;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($77f2946a7e231fe8$var$BannerText, null, children);
        $[7] = children;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== accessibilityProps || $[10] !== isWarning || $[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($77f2946a7e231fe8$var$BannerContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($77f2946a7e231fe8$var$Banner, {
            isWarning: isWarning,
            ...accessibilityProps
        }, t7, t8));
        $[9] = accessibilityProps;
        $[10] = isWarning;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== intl) {
        t10 = intl.formatMessage($77f2946a7e231fe8$var$BannerMessages.closeLabel);
        $[14] = intl;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            spacing: "spacious",
            label: t10
        });
        $[16] = t10;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== isWarning || $[19] !== onDismiss || $[20] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($77f2946a7e231fe8$var$BannerDismissButton, {
            "data-testid": "banner-dismiss-button",
            onClick: onDismiss,
            isWarning: isWarning,
            role: "button",
            tabIndex: 0
        }, t11);
        $[18] = isWarning;
        $[19] = onDismiss;
        $[20] = t11;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== height || $[23] !== isWarning || $[24] !== t12 || $[25] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($77f2946a7e231fe8$var$BannerContainer, {
            "data-testid": "banner-container",
            height: height,
            isWarning: isWarning
        }, t9, t12);
        $[22] = height;
        $[23] = isWarning;
        $[24] = t12;
        $[25] = t9;
        $[26] = t13;
    } else t13 = $[26];
    return t13;
};
module.exports["DismissibleBanner"] = $77f2946a7e231fe8$export$f43e5701f59b92d6;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("9mLIQ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $6d1b2fcade0e4c0b$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J4uP_",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("kFEr0"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-mSEo",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("kFEr0"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rSlGt",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $6d1b2fcade0e4c0b$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $6d1b2fcade0e4c0b$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82;

});

parcelRegister("kFEr0", function(module, exports) {

let $f0c70074a0ba4378$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0c70074a0ba4378$var$load("lkOIY"),
    $f0c70074a0ba4378$var$load("aowzi"),
    $f0c70074a0ba4378$var$load("7PE6o"),
    $f0c70074a0ba4378$var$load("dRpV3"),
    $f0c70074a0ba4378$var$load("6wr18"),
    $f0c70074a0ba4378$var$load("ffEVr"),
    $f0c70074a0ba4378$var$load("Wowvf"),
    $f0c70074a0ba4378$var$load("kHOMt"),
    $f0c70074a0ba4378$var$load("hhss7"),
    $f0c70074a0ba4378$var$load("7EorR"),
    $f0c70074a0ba4378$var$load("kUbUu"),
    $f0c70074a0ba4378$var$load("i4Poh")
]).then(()=>parcelRequire('FAgdQ'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});


//# sourceMappingURL=BannerContainer.60b4cf6b.js.map
